// La barra de «Ordenar» abajo, centrada en lo que se ve de la oficina: qué se hace y «Listo» (el único botón dorado mientras
// se ordena). Las mesas son automáticas desde el 04-11: ya no hay «Volver al reparto automático». Desde el 04-11 (orden.md
// regla 16) se ordena la oficina entera de una vez (tiemblan todas las salas), no sala a sala.
//
// Y el botón que lo enciende (`BotonOrdenar`). 05-11 (#278): en la fila de las cabeceras de sala, arriba a la derecha,
// parecía de la sala de esa esquina aunque mueve todas. Va al final de la franja de los widgets (marco/Escenario.tsx): la
// esquina de arriba a la derecha de la oficina, con su aire, como «Seleccionar» en Fotos: una cápsula gris.
import { Check, LayoutGrid } from 'lucide-react';
import { memo } from 'react';
import { t } from '../../../i18n';
import { cn } from '../../../lib/utils';
import { useOficinaStore } from '../store';
import { Boton } from '../ui';

export function BarraOrdenar({ centroX, alListo }: { centroX: number; alListo: () => void }) {
  return (
    <div
      role="status"
      className="absolute bottom-4 z-40 flex max-w-3xl -translate-x-1/2 items-center gap-3 rounded-o-m bg-oficina-elevada px-4 py-2.5 text-o-sub text-oficina-texto2 shadow-o-hoja"
      style={{ left: centroX }}
    >
      <span className="leading-snug">{t('oficinaV2.mesas.aviso')}</span>
      <button
        type="button"
        onClick={alListo}
        className="flex shrink-0 items-center gap-1.5 rounded-o-s bg-oficina-acento px-3 py-1.5 text-o-sub font-semibold text-oficina-acento-tinta outline-none transition-colors hover:bg-oficina-acento-hover focus-visible:ring-2 focus-visible:ring-oficina-enlace"
      >
        <Check className="h-4 w-4" aria-hidden />
        {t('oficinaV2.mesas.listo')}
      </button>
    </div>
  );
}

/** El único «Ordenar» de la oficina (por debajo de 1024 px, solo el icono; su nombre va en `aria-label`). Encendido: pulsado neutro con «Listo»; el único oro es el «Listo» de la barra. */
export const BotonOrdenar = memo(function BotonOrdenar() {
  const ordenando = useOficinaStore((s) => s.ordenandoMesas);
  const alternar = useOficinaStore((s) => s.setOrdenandoMesas);
  return (
    <Boton
      tamano="sm"
      icono={ordenando ? Check : LayoutGrid}
      onClick={() => alternar((o) => !o)}
      aria-pressed={ordenando}
      aria-label={ordenando ? t('oficinaV2.mesas.listo') : t('oficinaV2.mesas.ordenarOficina')}
      title={ordenando ? undefined : t('oficinaV2.mesas.ordenarOficina')}
      className={cn(ordenando && 'bg-oficina-pulsado')}
      data-testid="ordenar-oficina"
    >
      {/* Con la ventana estrecha (iPad en vertical) solo el icono: la palabra se comía el sitio de los widgets. */}
      <span className="max-lg:hidden">{ordenando ? t('oficinaV2.mesas.listo') : t('oficinaV2.mesas.ordenar')}</span>
    </Boton>
  );
});
